import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormTextArea from 'common/components/form/FormTextArea';
import FormSelect from 'common/components/form/FormSelect';
import { FormRow, FormElement } from 'common/components/form/FormLayout';
import MotiliButton from 'common/components-v2/buttons/MotiliButton';
import MotiliButtonContainer from 'common/components-v2/buttons/MotiliButtonContainer';
import Drawer from 'common/components-v2/modal/Drawer';

export default AdminWorkOrderRequirementsChecklistRevertModal;

const dropdownOptions = [
    {
        id: 'INCORRECTLY_MARKED',
        display: 'Was incorrectly marked as complete',
    },
    {
        id: 'WORK_NOT_INTENDED',
        display: 'Work was not completed as intended',
    },
    {
        id: 'OTHER',
        display: 'Other',
    },
];

function AdminWorkOrderRequirementsChecklistRevertModal({
    handleCloseOnClick,
    checklist,
    handleRevertOnClick,
    isOpen,
}) {
    const [dropdownOption, setDropdownOption] = useState('');
    const [reason, setReason] = useState('');
    const [busy, setBusy] = useState(false);
    const [uuid, setUuid] = useState('');

    useEffect(() => {
        if (isOpen) {
            setDropdownOption('');
            setReason('');
            setBusy(false);
            setUuid(crypto.randomUUID());
        }
    }, [isOpen]);
    return (
        <Drawer
            onClose={handleCloseOnClick}
            title={`Revert '${checklist?.requirement?.name}'`}
            closeByDocument={!busy}
            showClose={!busy}
            open={isOpen}
            drawerStyle={{ width: '45%' }}
        >
            <FormRow>
                <FormElement>
                    <div>
                        <em>
                            Please select a reason for reverting this checklist
                            on behalf of the contractor.
                        </em>
                    </div>
                </FormElement>
            </FormRow>
            <FormRow>
                <FormElement>
                    <FormSelect
                        key={uuid}
                        label='REASON'
                        options={dropdownOptions}
                        value={dropdownOption}
                        onChange={e => {
                            setDropdownOption(e);

                            if (e.id !== 'OTHER') {
                                setReason(e.display);
                                return;
                            }

                            setReason('');
                        }}
                    />
                </FormElement>
            </FormRow>
            {dropdownOption.id === 'OTHER' ? (
                <FormRow>
                    <FormElement>
                        <FormTextArea
                            label='OTHER REASON'
                            value={reason}
                            onChange={e => setReason(e.target.value)}
                        />
                    </FormElement>
                </FormRow>
            ) : null}
            <MotiliButtonContainer styles={{ marginTop: '20px' }}>
                <MotiliButton
                    text='Cancel'
                    onClick={handleCloseOnClick}
                    moStyle='normal'
                    disabled={busy}
                />
                <MotiliButton
                    text='Mark Incomplete'
                    onClick={() => {
                        setBusy(true);
                        handleRevertOnClick(checklist, reason);
                    }}
                    busy={busy}
                    disabled={!reason}
                />
            </MotiliButtonContainer>
        </Drawer>
    );
}

AdminWorkOrderRequirementsChecklistRevertModal.propTypes = {
    handleCloseOnClick: PropTypes.func.isRequired,
    handleRevertOnClick: PropTypes.func.isRequired,
    checklist: PropTypes.shape({
        requirement: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
};
